export const DEV_USER_ID = '00000000-0000-0000-0000-000000000123'

function base64UrlJson(value) {
  return btoa(JSON.stringify(value)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '')
}

export function createDevAccessToken(email = 'dev@local.test') {
  return [
    base64UrlJson({ alg: 'none', typ: 'JWT' }),
    base64UrlJson({
      sub: DEV_USER_ID,
      email,
      dev: true,
      exp: Math.floor(Date.now() / 1000) + 60 * 60 * 12,
    }),
    'dev',
  ].join('.')
}
